import { usePharmacyContext } from "@/features/pharmacy/usePharmacyContext";

export const useUserCountry = () => usePharmacyContext().pharmacy.country;
